// frontend/src/components/LoadingSplash.js
//
// Branded, event-gated loading splash shown after login/signup while the
// dashboard loads its props board (web counterpart of the mobile AnimatedSplash
// hold-until-ready mode). It stays until `ready` flips true, with a minimum so
// it never flashes; the max fail-safe lives in App.js.
import React, { useEffect, useRef, useState } from 'react';

const GOLD = '#f5c542';
const MIN_HOLD_MS = 1200;
const FADE_MS = 450;

const ORBIT = Array.from({ length: 3 }, (_, i) => {
  const a = (i / 3) * Math.PI * 2;
  return { x: Math.cos(a) * 86, y: Math.sin(a) * 86 };
});

const LoadingSplash = ({ ready, onFinish }) => {
  const [leaving, setLeaving] = useState(false);
  const mountTs = useRef(Date.now());
  const finished = useRef(false);

  useEffect(() => {
    if (!ready || finished.current) return;
    const wait = Math.max(0, MIN_HOLD_MS - (Date.now() - mountTs.current));
    const t = setTimeout(() => {
      finished.current = true;
      setLeaving(true);
      setTimeout(() => onFinish && onFinish(), FADE_MS);
    }, wait);
    return () => clearTimeout(t);
  }, [ready, onFinish]);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 2000,
        background: '#000',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: leaving ? 0 : 1,
        transition: `opacity ${FADE_MS}ms ease`,
      }}
    >
      <style>{`
        @keyframes lsIn { from { opacity:0; transform:scale(.7); } to { opacity:1; transform:scale(1); } }
        @keyframes lsBreathe { 0%,100% { transform:scale(1); } 50% { transform:scale(1.06); } }
        @keyframes lsSpin { to { transform: rotate(360deg); } }
        @keyframes lsUnderline { from { transform: scaleX(0); } to { transform: scaleX(1); } }
        @keyframes lsRise { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }
      `}</style>

      {/* Orbiting sparks (rotate a screen-centered layer) */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          animation: 'lsSpin 2.6s linear infinite',
        }}
      >
        {ORBIT.map((p, i) => (
          <span
            key={i}
            style={{
              position: 'absolute',
              width: 7,
              height: 7,
              borderRadius: 4,
              background: GOLD,
              transform: `translate(${p.x}px, ${p.y}px)`,
            }}
          />
        ))}
      </div>

      <img
        src="/pb-logo.png"
        alt=""
        style={{
          width: 120,
          height: 120,
          objectFit: 'contain',
          animation: 'lsIn .5s ease both, lsBreathe 1.8s ease-in-out infinite .5s',
        }}
      />
      <div style={{ color: '#fff', fontSize: 26, fontWeight: 900, letterSpacing: 4, marginTop: 20, animation: 'lsRise .5s ease both .25s' }}>
        PLAYERBET
      </div>
      <div style={{ width: 150, height: 3, background: GOLD, borderRadius: 2, marginTop: 10, transformOrigin: 'center', animation: 'lsUnderline .45s ease both .5s' }} />
    </div>
  );
};

export default LoadingSplash;
